<div class="container">
  <button (click)="export('csv')" class="btn-empty btn-with-icon " mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h3"> csv </span>
  </button>

  <button (click)="export('json')" class="btn-empty btn-with-icon" mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h3"> json </span>
  </button>
</div>
